import script from "./MenuBarButton.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuBarButton.vue?vue&type=script&setup=true&lang=js"

import "./MenuBarButton.vue?vue&type=style&index=0&id=9dcc225a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9dcc225a"]])

export default __exports__